import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'my-trainings',
  children: {
    detail: {
      path: ':trainingId',
      children: {
        view: {
          path: 'detail',
          children: {
            sessionDetail: {
              path: 'session/:sessionId',
              children: {
                certificates: {
                  path: 'certificates',
                  children: {
                    upload: {
                      path: 'upload',
                    },
                  },
                },
              },
            },
            files: {
              path: 'files/:trainingFileId',
              size: 'full',
            },
            certificates: {
              path: 'certificates',
              children: {
                upload: {
                  path: 'upload',
                },
              },
            },
          },
        },
      },
    },
    catalog: {
      path: 'catalog',
      children: {
        list: {
          path: 'list',
          children: {
            fromCatalog: {
              path: ':trainingId/from-catalog',
            },
            new: {
              path: 'new',
            },
          },
        },
        detail: {
          path: ':trainingId',
          children: {
            overview: {
              path: 'overview',
            },
            fromCatalog: {
              path: 'from-catalog',
            },
            materials: {
              path: 'materials',
              children: {
                previewFile: {
                  path: ':fileId/:fileType',
                  size: 'full',
                },
                certificate: {
                  path: 'upload-certificate',
                },
              },
            },
            sessions: {
              path: 'sessions',
              children: {
                sidepanel: {
                  path: ':sessionId/session-detail',
                },
              },
            },
          },
        },
      },
    },
    requests: {
      path: 'requests',
      children: {
        detail: {
          path: 'list/:id',
          children: {
            view: {
              path: 'list/:id',
            },
          },
        },
        list: {
          path: 'list',
          children: {
            new: {
              path: 'new',
            },
            fromCatalog: {
              path: 'fromCatalog',
            },
            requestDetailSidepanel: {
              path: ':id/request-detail-sidepanel',
            },
          },
        },
      },
    },
    revamp: {
      path: 'course-list',
      children: {
        detailsRevamp: {
          path: ':trainingId',
          children: {
            view: {
              path: 'training-detail',
              size: 'full',
              children: {
                overview: {
                  path: 'overview',
                },
                materials: {
                  path: 'materials',
                  children: {
                    certificate: {
                      path: 'upload-certificate',
                    },
                    file: {
                      path: 'files/:fileId/:fileType',
                    },
                  },
                },
                sessions: {
                  path: 'sessions',
                  children: {
                    sidepanel: {
                      path: ':sessionId/session-detail',
                    },
                    file: {
                      path: ':sessionId/files/:fileId',
                    },
                  },
                },
                certificates: {
                  path: 'certificates',
                  children: {
                    view: {
                      path: ':membershipFileId',
                    },
                    upload: {
                      path: 'upload',
                    },
                  },
                },
                contentOverview: {
                  path: 'content-overview',
                },
              },
            },
            content: {
              path: 'content',
              children: {
                block: {
                  path: ':blockId',
                },
              },
            },
          },
        },
        overview: {
          path: 'overview',
          children: {
            sidepanel: {
              path: ':trainingId/:sessionId/session-detail',
            },
          },
        },
      },
    },
    surveys: {
      path: 'surveys',
      children: {
        detail: {
          path: ':membership_id/answers/:materialized_form_id',
        },
        score: {
          path: ':membership_id/score/:materialized_form_id',
        },
      },
    },
  },
} as const satisfies Location
